import { ChangeDetectionStrategy, Component } from '@angular/core';
import { NgClass } from '@angular/common';

import { BaseColumnComponent } from '~components/dynamic-table/column-components/base-column.component';
import { StackedColumnModel } from '~components/dynamic-table/models/column-types/stacked-column.model';
import { Identifyable } from '~core/abstractions/identifyable';

@Component({
    selector: 'arc-stacked-column',
    templateUrl: './stacked-column.component.html',
    changeDetection: ChangeDetectionStrategy.Default,
    imports: [NgClass]
})
export class StackedColumnComponent<T extends Identifyable<TId>, TId = number> extends BaseColumnComponent<T, TId> {
    get castedColumnModel(): StackedColumnModel {
        return this.columnModel as StackedColumnModel;
    }
}
